import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui';
import React, { useEffect, useMemo, useState } from 'react';
import { DnDetalleComponent } from './PorDn/dnDetalleComponent';
import { GrupoFacturaDetalleComponent } from './PorGrupoFactura/grupoFacturaDetalleComponent';
import { SociedadDetalleComponent } from './PorSociedad/sociedadDetalleComponent';
import { UsuarioDetalleComponent } from './PorUsuarios/usuarioDetalleComponent';
import { FilterProps } from './screen';
import { getPermisoExpatriados } from '../../../../../shared/utils/constants';
import { PERFIL_ADMIN, ROLES_EXPATRIADOS } from '../../../../../shared/constanst/constants';

interface DetallePorops{
    filterConfig:FilterProps
    visible:boolean
    user:any
    onRefreshEstadoUsers?(paramRefresh:any):any
    translate(word:string):any
}

export const PanelDetalleFacturacionExpatriados = (props:DetallePorops) =>{

    const {filterConfig,visible,user,onRefreshEstadoUsers, translate}=props;

    const [filter,setFilter] = useState(filterConfig.filter)

    useEffect(()=>{setFilter(filterConfig.filter)},[filterConfig])

    const RolPermiso = useMemo(()=>{
        return (filter.selection && getPermisoExpatriados(filter.selection.rolPermiso))
    } ,[filter])

    const showFacturacion = useMemo(()=>visible && (user.perfil===PERFIL_ADMIN || (RolPermiso && RolPermiso.value === ROLES_EXPATRIADOS.ADMINISTRADOR.value))
    ,[user,RolPermiso,visible])

    const getSociedadContent = (dataFilter:any) => <SociedadDetalleComponent dataFilter={dataFilter} user={user} rolPermiso={RolPermiso} showFacturacion={showFacturacion} translate={translate}/>
    
    // const geDnContent = (dataFilter:any) => <DnDetalleComponent dataFilter={dataFilter} user={user} rolPermiso={RolPermiso} showFacturacion={showFacturacion} translate={translate}/>
    // const getGrupoFacturacionContent = (dataFilter:any) => <GrupoFacturaDetalleComponent dataFilter={dataFilter} rolPermiso={RolPermiso} showFacturacion={showFacturacion} user={user} translate={translate}/>
    // const getusuarioContent = (dataFilter:any) => <UsuarioDetalleComponent dataFilter={dataFilter} user={user} rolPermiso={RolPermiso} showFacturacion={showFacturacion} onRefreshEstadoUsers={onRefreshEstadoUsers} translate={translate}/>

    const getComponentTypeDetalle = () =>{
        const {filter} = filterConfig;
        return getSociedadContent(filter.selection);
        // switch (filter.tipo) {
        //     case 'sociedad': return getSociedadContent(filter.selection);
        //     case 'dn': return geDnContent(filter.selection);
        //     case 'grupoFactura': return getGrupoFacturacionContent(filter.selection);
        //     case 'usuario': return getusuarioContent(filter.selection);
        //     default: return null;
        // }
    }
   
    return (visible && RolPermiso) ? getComponentTypeDetalle() : null
}